import { FC } from 'react';

import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { concatWithDot } from 'helpers/string';
import { ObjectValues } from 'helpers/types';

import { EfficiencyForm } from '../EfficiencyForm';
import { efficiencyInitialValues, IEfficiencyFormValuesType } from '../EfficiencyForm/utils/form';
import { InvestmentForm } from '../InvestmentForm';
import { IInvestmentValuesType, investmentInitialValues } from '../InvestmentForm/utils/form';
import { LiquidityForm } from '../LiquidityForm';
import { ILiquidityFormValuesType, liquidityInitialValues } from '../LiquidityForm/utils/form';
import { ProfitabilityForm } from '../ProfitabilityForm';
import { IProfitabilityFormValuesType, profitabilityInitialValues } from '../ProfitabilityForm/utils/form';
import { SolvencyForm } from '../SolvencyForm/SolvencyForm';
import { ISolvencyFormValuesType, solvencyInitialValues } from '../SolvencyForm/utils/form';

export const financialPerformancePrefix = concatWithDot(
  BUSINESS_TOOL_SECTIONS.FINANCIAL_PLAN,
  BUSINESS_TOOL_SUB_SECTIONS.FINANCIAL_PLAN.FINANCIAL_PERFORMANCE,
);

export const FINANCIAL_PERFORMANCE_OPTION_NAMES = {
  INVESTMENT: 'investment',
  PROFITABILITY: 'profitability',
  LIQUIDITY: 'liquidity',
  EFFICIENCY: 'efficiency',
  SOLVENCY: 'solvency',
} as const;

export const investmentFormPrefix = concatWithDot(
  financialPerformancePrefix,
  FINANCIAL_PERFORMANCE_OPTION_NAMES.INVESTMENT,
);
export const profitabilityFormPrefix = concatWithDot(
  financialPerformancePrefix,
  FINANCIAL_PERFORMANCE_OPTION_NAMES.PROFITABILITY,
);
export const liquidityFormPrefix = concatWithDot(
  financialPerformancePrefix,
  FINANCIAL_PERFORMANCE_OPTION_NAMES.LIQUIDITY,
);
export const efficiencyFormPrefix = concatWithDot(
  financialPerformancePrefix,
  FINANCIAL_PERFORMANCE_OPTION_NAMES.EFFICIENCY,
);
export const solvencyFormPrefix = concatWithDot(
  financialPerformancePrefix,
  FINANCIAL_PERFORMANCE_OPTION_NAMES.SOLVENCY,
);

export type IFinancialPerformanceValuesType = ObjectValues<typeof FINANCIAL_PERFORMANCE_OPTION_NAMES>;

export const financialPlanOptionsToComponentMap: Record<IFinancialPerformanceValuesType, FC> = {
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.INVESTMENT]: InvestmentForm,
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.PROFITABILITY]: ProfitabilityForm,
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.LIQUIDITY]: LiquidityForm,
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.EFFICIENCY]: EfficiencyForm,
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.SOLVENCY]: SolvencyForm,
};

export interface IFinancialPerformance {
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.INVESTMENT]: IInvestmentValuesType;
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.PROFITABILITY]: IProfitabilityFormValuesType;
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.LIQUIDITY]: ILiquidityFormValuesType;
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.EFFICIENCY]: IEfficiencyFormValuesType;
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.SOLVENCY]: ISolvencyFormValuesType;
}

export const financialPerformanceInitialValues = {
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.INVESTMENT]: investmentInitialValues,
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.PROFITABILITY]: profitabilityInitialValues,
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.LIQUIDITY]: liquidityInitialValues,
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.EFFICIENCY]: efficiencyInitialValues,
  [FINANCIAL_PERFORMANCE_OPTION_NAMES.SOLVENCY]: solvencyInitialValues,
};
